// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoCircleFilledSvg from "@fishx/icons-svg/es/asn/TaobaoCircleFilled";
import FishxIcon from '../components/FishxIcon';

var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleFilledSvg
  }));
};

TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
export default React.forwardRef(TaobaoCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TaobaoCircleFilled.js
// module id = 4248
// module chunks = 0